/* istanbul ignore file */
import styled from 'styled-components';
import { ColumnDiv, Text } from 'components/Div/styles';

interface ButtonPrimaryProps {
  light?: boolean;
}

export const LoginContainer = styled(ColumnDiv)`
  flex: 1 1 auto;
  background: ${props => props.theme.backgroundColorShadeTwo};
`;

export const LoginPanel = styled.form`
  background: white;
  padding: 50px;
  margin: 8em auto 0;
  width: 400px;
`;

export const FieldWrapper = styled(ColumnDiv)`
  margin-top: 1.5em;
  display: flex;
  padding: 0;
`;

export const LoginInput = styled.input`
  font-size: 16px;
`;

export const Label = styled(Text).attrs({ as: 'label' })``;

export const ErrorMessage = styled(Text)`
  color: red;
`;

export const ButtonPrimary = styled.button<ButtonPrimaryProps>`
  background-color:
    ${({ theme,
    light }) => (light
    ? theme.buttonPrimaryBackgroundColorShadeTwo
    : theme.buttonPrimaryBackgroundColorShadeOne)};
  color:
    ${({ theme,
    light }) => (light
    ? theme.buttonPrimaryFontColorShadeTwo
    : theme.buttonPrimaryFontColorShadeOne)};
  border: 2px solid ${({ theme }) => theme.buttonPrimaryBorderColorShadeOne};
  border-radius: 20px;
  font-size: 16px;
  font-family: ${({ theme }) => theme.fontFamilyPrimary};
  padding: 15px 25px;
  font-weight: bold;
`;

export const LoginButton = styled(ButtonPrimary)``;
